import { render } from "./TableHistoty.vue?vue&type=template&id=8ba8e0ee&ts=true"
import script from "./TableHistoty.vue?vue&type=script&lang=ts"
export * from "./TableHistoty.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__